"use client";

import { useEffect } from "react";
import {
  captureAttribution,
  setAttributionCookie,
} from "@/lib/attribution";

/**
 * AttributionCapture component
 * Captures attribution data on first page visit and stores it in a cookie
 * This component should be added to the root layout to run on all pages
 */
export function AttributionCapture() {
  useEffect(() => {
    try {
      // Only capture attribution on first visit (if cookie doesn't exist)
      const attribution = captureAttribution();

      if (attribution) {
        // Set cookie - this will only set if cookie doesn't already exist
        setAttributionCookie(attribution);
      }
    } catch (error) {
      // Silent failure - attribution errors should never affect user experience
      console.error("Attribution capture failed:", error);
    }
  }, []);

  // This component doesn't render anything
  return null;
}
